const LOGO_LIST_STALE_KEY = "logo-list-needs-refresh";

export function markLogoListAsStale() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    sessionStorage.setItem(LOGO_LIST_STALE_KEY, "true");
  } catch (error) {
    console.error("Failed to persist logo refresh flag:", error);
  }
}

export function consumeLogoListStaleFlag(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const shouldRefresh = sessionStorage.getItem(LOGO_LIST_STALE_KEY) === "true";
    if (shouldRefresh) {
      sessionStorage.removeItem(LOGO_LIST_STALE_KEY);
    }

    return shouldRefresh;
  } catch (error) {
    console.error("Failed to read logo refresh flag:", error);
    return false;
  }
}

